import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const initI18nClientSide = async () => {
  const { translations } = window as any;
  return i18n.use(initReactI18next).init({
    load: 'languageOnly', // we only provide en, de -> no region specific locals like en-US, de-DE
    lng: 'en',
    fallbackLng: 'en',
    debug: false,
    resources: {
      en: {
        translations: JSON.parse(translations),
      },
    },
    ns: ['translations'],
    defaultNS: 'translations',
    keySeparator: false,
    interpolation: {
      escapeValue: false, // not needed for react!!
      prefix: '{',
      suffix: '}',
      formatSeparator: ',',
    },
    react: {
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'b', 'em'],
    },
  });
};

export default initI18nClientSide;
